import * as React from "react";

import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

export class MaritalStatusStep extends React.Component<IStepProps, IStepState> {
    state: IStepState;

    constructor(props: IStepProps) {
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);

        this.state = {
            redirectPath: "",
            goToNextStep: false
        }
    }

    handleOnClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        let valueElement = event.target as HTMLAnchorElement;
        let value = valueElement.dataset["value"];

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.primaryDriver.married = value;

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.IS_MILITARY);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    getSelectedClass(optionValue: string): string {
        if (optionValue === this.props.model.primaryDriver.married) {
            return "selected";
        }
        return "";
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const sectionStyle = {
            display: 'block'
        }

        return <React.Fragment>
            <LogStep lastStep="Incidents" nextStep="IsMilitary" stepNumber={QuoteFormEventType.MarriedStep} sectionName="IsMilitary" wizardName="AutoWizard" logStep={true}/>
            <div id="MaritalStatusStep" className={sectionClasses} style={sectionStyle}>
                   <h3>Married?</h3>
                   <div id="Married">
                       <div className="touch-list twoColumn">
                            <div className="touch-list-option"><a className={this.getSelectedClass("True")} id="married_Yes" data-value="True" onClick={this.handleOnClick}>Yes</a></div>
                            <div className="touch-list-option"><a className={this.getSelectedClass("False")} id="married_No" data-value="False" onClick={this.handleOnClick}>No</a></div>
                       </div>
                   </div>
            </div>
        </React.Fragment>;
    }
}





    